// extracted by mini-css-extract-plugin
module.exports = {"container":"stlyes-module--container--cavIY","label":"stlyes-module--label--3gbc6","icon":"stlyes-module--icon--z13YM"};